const module = { name: 'desktop/shared/Fandango.calendar', exports: {} }; const exports = module.exports;



import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from 'require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { Fandango_util as Fandango_util_formatDate } from 'require-global';

const { formatDate } = Fandango_util_formatDate;


import { fd_location as fd_location_getLocation } from 'require-global';

const { getLocation } = fd_location_getLocation;


import { Fandango as Fandango_movieDetails } from 'require-core';

const { movieDetails } = Fandango_movieDetails;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as datePicker } from 'swug-fdRequire-call:movie/shared/datePicker';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    CALENDAR_WRAP: '.js-movie-calendar',
    LEFT_FLIPPER: '.js-calendar-flipper-left',
    RIGHT_FLIPPER: '.js-calendar-flipper-right',
    DATE_LINK: '.date-picker__link'
}


const minCalendarDates = 7
function formatDay(day) {
    const formatted = day.toString();
    if (formatted.length === 1) {
        return '0' + formatted;
    }
    return formatted;
}
function addCalendarMockData(data) {
    const allCalendarDates = data.movieCalendar.calendar;
    const diff = minCalendarDates - allCalendarDates.length;
    const oneDay = 1 * 86400000;
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    for (let i = 0; i < diff; i++) {
        const lastDate = allCalendarDates[allCalendarDates.length - 1];
        const lastDateObj = new Date(lastDate.full.replace(/-/g, '/'));
        const nextDate = new Date(lastDateObj.setTime(lastDateObj.getTime() + oneDay));
        const mockData = {
            day: formatDay(nextDate.getDate()),
            dayNameShort: '',
            full: nextDate.getFullYear() + '-' + formatDay(nextDate.getMonth() + 1) + '-' + formatDay(nextDate.getDate()),
            hasShowtime: false,
            month: (nextDate.getMonth() + 1),
            monthNameShort: monthNames[nextDate.getUTCMonth()],
            year: nextDate.getFullYear()
        };
        allCalendarDates.push(mockData);
    }
    allCalendarDates.push({ emptyItem: true });
}
function initCarousel(scrollCount) {
    const $calendarWrap = $(Selectors.CALENDAR_WRAP);
    const $leftFlipper = $(Selectors.LEFT_FLIPPER);
    const $rightFlipper = $(Selectors.RIGHT_FLIPPER);
    const itemsToScroll = scrollCount || 1;
    $calendarWrap.jcarousel()
        .on('jcarousel:visiblein', 'li', function () {
        $(this).find(Selectors.DATE_LINK).attr('tabindex', 0);
    })
        .on('jcarousel:visibleout', 'li', function () {
        $(this).find(Selectors.DATE_LINK).attr('tabindex', -1);
    })
        .jcarousel('visible').each(function () {
        $(this).trigger('jcarousel:visiblein');
    });
    $calendarWrap.jcarousel('scroll', $('.date-picker__date--selected'));
    $leftFlipper
        .on('jcarouselcontrol:active', () => {
        $leftFlipper.removeClass('flipper--hide');
        $leftFlipper.attr('tabindex', 0);
    }).on('jcarouselcontrol:inactive', () => {
        $leftFlipper.addClass('flipper--hide');
        $leftFlipper.attr('tabindex', -1);
    }).jcarouselControl({
        target: '-=' + itemsToScroll
    });
    $rightFlipper
        .on('jcarouselcontrol:active', () => {
        $rightFlipper.removeClass('flipper--hide');
        $rightFlipper.attr('tabindex', 0);
    }).on('jcarouselcontrol:inactive', () => {
        $rightFlipper.addClass('flipper--hide');
        $rightFlipper.attr('tabindex', -1);
    }).jcarouselControl({
        target: '+=' + itemsToScroll
    });
}
function onCalendarDone(data) {
    if (data.movieCalendar.calendar.length <= minCalendarDates) {
        addCalendarMockData(data);
    }
    const $markup = $(swig.render('_calendar', {
        data,
        releaseDate: formatDate(movieDetails.releaseDate)
    }));
    $(Selectors.CALENDAR_WRAP).html($markup);
    if (data.selectedDate) {
        window.Fandango.selectedDate = data.selectedDate;
    }
    datePicker.markToday();
    datePicker.highlightDate($(Selectors.CALENDAR_WRAP), window.Fandango.selectedDate);
    initCarousel();
}
function onCalendarFail(err) {
    debugLog.warn('Movie Calendar API Fail', err);
}
function updateCalendar(location, date) {
    let url = links.napiMovieCalendar({
        title: movieDetails.title,
        id: movieDetails.id
    });
    if (date) {
        url += '?date=' + date;
    }
    xhr.ajax({
        url,
        params: location.params,
        method: 'GET'
    })
        .done(onCalendarDone)
        .fail(onCalendarFail);
}
function init() {
    const date = dateFromQuery();
    if (date) {
        window.Fandango.selectedDate = date;
    }
    const location = getLocation();
    if ($(Selectors.CALENDAR_WRAP).length && location.params) {
        updateCalendar(location, date);
    }
}
module.exports = {
    init,
    initCarousel
};
export default module.exports;